import { VK } from './define'
import { InternalActionKeyId } from '@libs/define/internal_action_key_id'

export { InternalActionKeyId } from '@libs/define/internal_action_key_id'

export enum InternalActionGroup {
  deviceFunction = 'deviceFunction',
}

export interface InternalActionKeyDef {
  id: VK
  group: InternalActionGroup
  labelKey: string
  iconKey: string
}

const internalActionKeys: InternalActionKeyDef[] = [
  {
    id: InternalActionKeyId.deviceLightBrightnessDown,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_light_brightness_down',
    iconKey: 'B-',
  },
  {
    id: InternalActionKeyId.deviceLightBrightnessUp,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_light_brightness_up',
    iconKey: 'B+',
  },
  {
    id: InternalActionKeyId.deviceLightSpeedDown,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_light_speed_down',
    iconKey: 'S-',
  },
  {
    id: InternalActionKeyId.deviceLightSpeedUp,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_light_speed_up',
    iconKey: 'S+',
  },
  {
    id: InternalActionKeyId.deviceLightEffectMode,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_light_effect_mode',
    iconKey: 'FX',
  },
  {
    id: InternalActionKeyId.deviceLightColorSwitch,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_light_color_switch',
    iconKey: 'CLR',
  },
  {
    id: InternalActionKeyId.deviceWinMacModeSwitch,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_win_mac_mode_switch',
    iconKey: 'W/M',
  },
  {
    id: InternalActionKeyId.deviceSwitchToWindowsMode,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_switch_to_windows_mode',
    iconKey: 'WIN',
  },
  {
    id: InternalActionKeyId.deviceSwitchToMacMode,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_switch_to_mac_mode',
    iconKey: 'MAC',
  },
  {
    id: InternalActionKeyId.deviceWinKeyLock,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_win_key_lock',
    iconKey: 'WLK',
  },
  {
    id: InternalActionKeyId.deviceLightDirection,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'light_direction',
    iconKey: 'DIR',
  },
  {
    id: InternalActionKeyId.deviceFn1,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_fn1',
    iconKey: 'FN1',
  },
  {
    id: InternalActionKeyId.deviceFn2,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_fn2',
    iconKey: 'FN2',
  },
  {
    id: InternalActionKeyId.deviceFn3,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_fn3',
    iconKey: 'FN3',
  },
  {
    id: InternalActionKeyId.deviceRestore,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'action_set_reset',
    iconKey: 'RST',
  },
  {
    id: InternalActionKeyId.deviceLightToggle,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_light_toggle',
    iconKey: 'LED',
  },
  {
    id: InternalActionKeyId.deviceLogoLightEffectMode,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_logo_light_effect_mode',
    iconKey: 'LFX',
  },
  {
    id: InternalActionKeyId.deviceSnapTapToggle,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_snap_tap',
    iconKey: 'ST',
  },
  {
    id: InternalActionKeyId.deviceSideLightBrightnessDown,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_side_light_brightness_down',
    iconKey: 'SB-',
  },
  {
    id: InternalActionKeyId.deviceSideLightBrightnessUp,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_side_light_brightness_up',
    iconKey: 'SB+',
  },
  {
    id: InternalActionKeyId.deviceSideLightSpeedDown,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_side_light_speed_down',
    iconKey: 'SS-',
  },
  {
    id: InternalActionKeyId.deviceSideLightSpeedUp,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_side_light_speed_up',
    iconKey: 'SS+',
  },
  {
    id: InternalActionKeyId.deviceSideLightEffectMode,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_side_light_effect_mode',
    iconKey: 'SFX',
  },
  {
    id: InternalActionKeyId.deviceSideLightColorSwitch,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_side_light_color_switch',
    iconKey: 'SCL',
  },
  {
    id: InternalActionKeyId.deviceSideLightToggle,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_side_light_toggle',
    iconKey: 'SLED',
  },
  {
    id: InternalActionKeyId.deviceSideLightDirection,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_side_light_direction',
    iconKey: 'SDIR',
  },
  {
    id: InternalActionKeyId.deviceSideLightEffectPrev,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_side_light_effect_prev',
    iconKey: 'SF-',
  },
  {
    id: InternalActionKeyId.deviceSideLightEffectNext,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_side_light_effect_next',
    iconKey: 'SF+',
  },
  {
    id: InternalActionKeyId.deviceSwitchToProfile1,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_switch_to_profile_1',
    iconKey: 'C1',
  },
  {
    id: InternalActionKeyId.deviceSwitchToProfile2,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_switch_to_profile_2',
    iconKey: 'C2',
  },
  {
    id: InternalActionKeyId.deviceSwitchToProfile3,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_switch_to_profile_3',
    iconKey: 'C3',
  },
  {
    id: InternalActionKeyId.deviceSwitchToProfile4,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_switch_to_profile_4',
    iconKey: 'C4',
  },
  {
    id: InternalActionKeyId.deviceCycleProfiles,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_cycle_profiles',
    iconKey: 'CCY',
  },
  {
    id: InternalActionKeyId.deviceOpenWebDriver,
    group: InternalActionGroup.deviceFunction,
    labelKey: 'device_fn_open_web_driver',
    iconKey: 'WEB',
  },
]

const internalActionKeyMap = new Map<VK, InternalActionKeyDef>()

for (const item of internalActionKeys) {
  internalActionKeyMap.set(item.id, item)
}

export const getInternalActionKeysByGroup = (group: InternalActionGroup): InternalActionKeyDef[] => {
  return internalActionKeys.filter((item) => item.group === group)
}

export const getInternalActionKeysByIds = (ids: VK[]): InternalActionKeyDef[] => {
  return ids.map((id) => internalActionKeyMap.get(id)).filter((item): item is InternalActionKeyDef => item !== undefined)
}

export const getInternalActionKeyDef = (id: VK): InternalActionKeyDef | undefined => {
  return internalActionKeyMap.get(id)
}

export const isInternalActionKey = (id: VK): boolean => {
  return internalActionKeyMap.has(id)
}

export const isDeviceFunctionActionKey = (id: VK): boolean => {
  const key = internalActionKeyMap.get(id)
  return key?.group === InternalActionGroup.deviceFunction
}

export const getDeviceFunctionActionKeys = (): InternalActionKeyDef[] => {
  return getInternalActionKeysByGroup(InternalActionGroup.deviceFunction)
}
